module.exports = __webpack_public_path__ + "img/title.3bece482.png";